import React from 'react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-209" data-mp="30wohs94qq3vn">
      <div className="mx-auto max-w-6xl" data-id="element-210" data-mp="30zazh1lchzrl">
        <div className="mx-auto max-w-2xl text-center" data-id="element-211" data-mp="2w5yfj4rm2h56">
          <h2 className="font-display text-[1.8rem] font-extrabold leading-tight tracking-tight text-navy sm:text-[2.6rem]" data-id="element-212" data-mp="2w4eul0v0fhx2">
            <span aria-hidden="true" data-id="element-213" data-mp="2m8256f6hzq84">😰 </span>Erkennst du dich in diesen Situationen wieder?
          </h2>
          <p className="mt-4 text-base text-navy/65" data-id="element-214" data-mp="2i674ncwe5gve">
            Wenn du mindestens einmal mit Ja geantwortet hast, ist dieses Paket für dich.
          </p>
        </div>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-6" data-id="element-215" data-mp="2d9gnsncrih8x">
          {recognizeItems.map((item, index) => {
          const Icon = item.icon;
          return <li key={item.title} className={`flex flex-col rounded-2xl bg-ice p-6 lg:col-span-2 ${index === 3 ? 'lg:col-start-2' : ''}`} data-id="element-216" data-mp="bfhbpzrtfvv6" data-mpi={index}>
                <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${item.tone}`} data-id="element-217" data-mp="3nmp3v7k5po6g">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-218" data-mp="39nxshswoigm0" />
                </span>
                <h3 className="mt-4 font-display text-lg font-extrabold text-navy" data-id="element-219" data-mp="3el7gd44f6k7q">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-navy/70" data-id="element-220" data-mp="65xgm2o05r34">{item.text}</p>
              </li>;
        })}
        </ul>

        <p className="mt-12 text-center" data-id="element-221" data-mp="b4h3c5af76wj">
          <a href="#offer" className="font-display text-2xl font-extrabold text-brand transition-colors duration-150 ease-out hover:text-brand-dark sm:text-3xl" data-id="element-222" data-mp="3sma4rniw06lt">
            Du verdienst mehr als das →
          </a>
        </p>
      </div>
    </section>;
}